import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { SWIPER_NO_SWIPING_CLASS } from '../../../../helpers/const'
import VideoControls from './VideoControls'

const StyledSeek = styled.input(({ theme: { colors } }) => ({
  position: 'absolute',
  WebkitAppearance: 'none',
  top: 0,
  width: '100%',
  cursor: 'pointer',
  margin: 0,
  backgroundColor: 'rgba(255,255,255,.3)',
  height: '6px',
  borderRadius: '5px',
  '&::-webkit-slider-thumb': {
    WebkitAppearance: 'none',
    border: '1px solid rgba(0,0,0,.2)',
    height: '15px',
    width: '15px',
    borderRadius: '50%',
    background: colors.primary,
  },
}))

const StyledProgress = styled.div(({ theme: { colors }, played }) => ({
  WebkitAppearance: 'none',
  borderRadius: '2px',
  backgroundColor: colors.primary,
  width: !played ? '0%' : `${played * 100}%`,
  height: '5px',
  pointerEvents: 'none',
  position: 'absolute',
  top: 0,
  zIndex: 1,
}))

const StyledVideoProgress = styled.div(() => ({
  position: 'relative',
  height: '4px',
  marginBottom: '5px',
  width: '100%',
}))

const StyledVideoBar = styled.div(({ theme: { breakpoints } }) => ({
  right: 0,
  left: 0,
  padding: '0 10px 10px 10px',
  position: 'absolute',
  bottom: 0,
  height: '90px',
  transition: 'all 0.2s ease',
  backgroundImage: ' linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5))',
  zIndex: '2147483648',
  [`@media (min-width: ${breakpoints.medium})`]: {
    padding: '0 30px 10px 30px',
  },
}))

const VideoBar = ({
  playing,
  muted,
  played,
  togglePlaying,
  toggleFullscreen,
  toggleMuted,
  onChange,
}) => (
  <StyledVideoBar>
    <VideoControls
      togglePlaying={togglePlaying}
      toggleFullscreen={toggleFullscreen}
      toggleMuted={toggleMuted}
      muted={muted}
      playing={playing}
    />
    <StyledVideoProgress className={`video-progress ${SWIPER_NO_SWIPING_CLASS}`}>
      <StyledProgress played={played} />
      <StyledSeek
        className="seek"
        type="range"
        min={0}
        max={1}
        step="any"
        value={played}
        onChange={onChange}
      />
    </StyledVideoProgress>
  </StyledVideoBar>
)

VideoBar.propTypes = {
  playing: PropTypes.bool,
  muted: PropTypes.bool,
  played: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  togglePlaying: PropTypes.func,
  toggleFullscreen: PropTypes.func,
  toggleMuted: PropTypes.func,
}

VideoBar.defaultProps = {
  playing: false,
  muted: false,
  played: '',
  onChange: () => false,
  togglePlaying: () => false,
  toggleFullscreen: () => false,
  toggleMuted: () => false,
}

VideoBar.displayName = 'VideoBar'
VideoBar.whyDidYouRender = true

export default VideoBar
